import '@css/main.pcss'

import Alpine from 'alpinejs'
import AsyncAlpine from 'async-alpine'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import validate from '@colinaut/alpinejs-plugin-simple-validate'

document.addEventListener('alpine:initialized', () => {
  document.documentElement.classList.remove('is-loading')
})

AsyncAlpine
  .init(Alpine)
  .data('slider', () => import('./components/slider'))
  .data('jobApplication', () => import('./components/job-application'))
  .start()

Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.plugin(validate)
Alpine.plugin(intersect)

Alpine.store('menuOpen', false)

Alpine.start()
window.Alpine = Alpine
